import { render } from "./PerformanceBreakdown.vue?vue&type=template&id=2d65d6b3&scoped=true"
import script from "./PerformanceBreakdown.vue?vue&type=script&lang=js"
export * from "./PerformanceBreakdown.vue?vue&type=script&lang=js"

import "./PerformanceBreakdown.vue?vue&type=style&index=0&id=2d65d6b3&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d65d6b3"]])

export default __exports__